<template>
  <basic-list
    :show-index-col="false"
    :fields="fields"
    select-type="singleMult"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    :table-h="tableH"
    :showActionCol="false"
    :showSelectCol="true"
    :page-index="state.pageIndex"
    :page-size="state.pageSize"
    :page-index-change="pageIndexChange"
    :selection-change="selectionChange"
    :page-size-change="pageSizeChange"
    :show-ext-set="buttonData('cdjskz2').has"
    :ext-dlg-vis="updateExtDlgVis"
  >
    <template slot="hd-col--l">
      <el-button
        type="primary"
        :size="btnSize"
        @click="proxyActions({ action: 'onAdd', rows: selRows })"
        v-if="buttonData('tjcdjs2').has"
        >{{ buttonData("tjcdjs2").name }}</el-button
      >
      <el-button
        type="primary"
        :size="btnSize"
        @click="proxyActions({ action: 'distribute', rows: selRows })"
        v-if="buttonData('cdjefpcdjs2').has"
        >{{ buttonData("cdjefpcdjs2").name }}</el-button
      >
      <!-- <el-button type="primary" :size="btnSize" @click="proxyActions({ action: 'copyUser', rows: selRows })">{{'复制菜单角色'}}</el-button> -->
      <el-button
        :size="btnSize"
        @click="proxyActions({ action: 'edit', rows: selRows })"
        v-if="buttonData('bjcdjs2').has"
        >{{ buttonData("bjcdjs2").name }}</el-button
      >
      <el-button
        :size="btnSize"
        @click="proxyActions({ action: 'view', rows: selRows })"
        v-if="buttonData('cdjsxq2').has"
        >{{ buttonData("cdjsxq2").name }}</el-button
      >
      <el-button
        type="danger"
        :size="btnSize"
        @click="proxyActions({ action: 'delet', rows: selRows })"
        v-if="buttonData('sccdjs2').has"
        >{{ buttonData("sccdjs2").name }}</el-button
      >
      <!-- 启用 -->
      <el-button
        v-if="buttonData('qycdjs2').has && isDisable"
        :size="btnSize"
        @click="handleEnableOrDisable"
        >{{ buttonData("qycdjs2").name }}</el-button
      >
      <!-- 停用 -->
      <el-button
        v-if="buttonData('tycdjs2').has && isEnable"
        :size="btnSize"
        @click="handleEnableOrDisable"
        >{{ buttonData("tycdjs2").name }}</el-button
      >
      <!-- 导入菜单角色 -->
      <el-button
        v-if="buttonData('CDJSDR').has && showExportButton"
        :size="btnSize"
        @click="importRole(buttonData('CDJSDR2').name)"
        >{{ buttonData("CDJSDR2").name }}</el-button
      >
      <!-- 导入角色资源 -->
      <el-button
        v-if="buttonData('DRCDJSZY2').has && showExportButton"
        :size="btnSize"
        @click="importRoleResource(buttonData('DRCDJSZY2').name)"
        >{{ buttonData("DRCDJSZY2").name }}</el-button
      >
      <!-- 导出 -->
      <!-- <el-dropdown
        split-button
        v-if="showExportButton"
        type="primary"
        :size="btnSize"
        @command="exportMenuRole"
        trigger="click"
      >
        {{$t('language.5o6veotsluc0')}}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-if="buttonData('DCCDJS2').has"
            divided
            :command="[0, `${$t('language.5o6veotsmas0')}`]"
            >{{ buttonData("DCCDJS2").name }}</el-dropdown-item
          >
          <el-dropdown-item
            v-if="buttonData('DCYHCDJS2').has"
            divided
            :command="[1, `${$t('language.5o6veotsmeo0')}`]"
            >{{ buttonData("DCYHCDJS2").name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
    </template>
  </basic-list>
</template>

<script>
import ExactList from "@/mixins/exactList";
export default {
  mixins: [ExactList],
  props: {
    proxyActions: Function,
    exportMenuRole: Function,
    importRole: Function,
    importRoleResource: Function,
  },

  mounted() {
    console.log(this.showButtonList, this.tenementCode, "asdwasd");
  },
  data() {
    return {
      fields: [
        { key: "roleName", name: `${this.$t('language.5o6veotsmhk0')}` },
        { key: "roleCode", name: `${this.$t('language.5o6veotsmk40')}` },
        {
          key: "isDisable",
          name: `${this.$t('language.5o6u3frcncs0')}`,
          render: (h, { row }) => {
            const status = { 0: `${this.$t('language.5o6trh9vmow0')}`, 1: `${this.$t('language.5o6trh9vmrs0')}` };
            const value = status[row.isDisable];
            return <span>{value}</span>;
          },
        },
        {
          key: "sensitiveMark",
          name: `${this.$t('language.5o6uj7uyt780')}`,
          render: (h, { row }) => {
            const status = { 0: `${this.$t('language.5o6uj7uyta00')}`, 1: `${this.$t('language.5o6uj7uytcs0')}` };
            const value = status[row.sensitiveMark];
            return <span>{value}</span>;
          },
        },
        { key: "ext1", name: "", hidden: true },
        { key: "ext2", name: "", hidden: true },
        { key: "ext3", name: "", hidden: true },
        { key: "ext4", name: "", hidden: true },
        { key: "ext5", name: "", hidden: true },
        { key: "ext6", name: "", hidden: true },
        { key: "ext7", name: "", hidden: true },
        { key: "ext8", name: "", hidden: true },
        { key: "ext9", name: "", hidden: true },
        { key: "ext10", name: "", hidden: true },
        { key: "createUser", name: `${this.$t('language.5o6trh9vn2w0')}` },
        { key: "createTime", name: `${this.$t('language.5o6otz4p1t00')}`, width: 200 },
        { key: "rootOrgName", name: `${this.$t('language.5o6uj7uytl10')}` },
        { key: "roleSource", name: `${this.$t('language.5o6otz4p1ps0')}` },
        { key: "remark", name: `${this.$t('language.5o6otz4p1w00')}` },
      ],
      btnSize: "mini",
    };
  },
  computed: {
    isEnable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 0 ? true : false;
    },
    isDisable() {
      return this.selRows.length !== 0 && this.selRows[0].isDisable === 1 ? true : false;
    },
  },
  methods: {
    // 禁用/启用菜单角色
    handleEnableOrDisable() {
      if (this.selRows.length === 0) return;
      // 0表示启用状态 1表示禁用状态
      const { isDisable, tenementCode, id } = this.selRows[0];
      const params = { data: { tenementCode, id } };
      if (isDisable === 0) {
        this.handleDisableResourceRole(params);
      } else if (isDisable === 1) {
        this.handleEnableResourceRole(params);
      }
    },
    // 禁用
    async handleDisableResourceRole(params) {
      const { code, msg } = await api.rolePermissions.disableResourceRole(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    // 启用
    async handleEnableResourceRole(params) {
      const { code, msg } = await api.rolePermissions.enableResourceRole(params);
      if (code === 200) {
        this.$message.success(msg);
        this.$emit("UPDATE_LIST");
      } else {
        this.$message.error(msg);
      }
    },
    updateExtDlgVis() {
      this.$parent.showDialog(`${this.$t('language.5o6u3frcno10')}`, "extRoleWinShow");
    },
  },
};
</script>
